import { useQuery } from "@tanstack/react-query";
import { useDocumentService } from "contexts/ServiceContext";
import { AI_EVENTS, useTrackEvent } from "hooks/useAppInsight";
import mapApiDocumentFilterDimensions from "./mapApiDocumentFilterDimensions";

const useGetDocumentInvoiceFilterDimensions = (cardCodes: string[]) => {
  const documentService = useDocumentService();

  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    cardCodes,
  });

  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    cardCodes,
  });

  return useQuery({
    queryKey: ["documentInvoiceFilterDimensions", { cardCodes }],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "/Invoice/GetDocumentFilterDimensions",
      });
      return documentService
        .getDocumentInvoiceFilterDimensions(cardCodes)
        .then((data) => mapApiDocumentFilterDimensions(data))
        .catch((err) => {
          trackQueryError(
            {
              statusCode: err.statusCode as number,
              message: err.message,
            },
            eventId
          );
          throw err;
        });
    },
  });
};

export default useGetDocumentInvoiceFilterDimensions;
